import { Component } from "@angular/core";

@Component({
  selector: "app-edit-request-template",
  templateUrl: "./edit-request-template.component.html",
  styleUrls: ["./edit-request-template.component.scss"],
})
export class EditRequestTemplateComponent {}
